import React, { Component } from "react";
import Header from "./components/Header";
import HeroSlider from "./components/HeroSlider";
import TeamSlider from "./components/TeamSlider";
import Footer from "./components/Footer";
import { homeData } from "./data/homeData";
import HomeBlog from "./components/HomeBlog";
import HomeAbout from "./components/HomeAbout";
import PartnerSlider from "./components/PartnerSlider";

export default class HomeOne extends Component {
  render() {
    return (
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Hero Slider */}
        <HeroSlider data={homeData && homeData.sliders} />

        {/* Home About */}
        <HomeAbout />
<div style={{width:"100%"}}><img style={{ width: "100%", margin: "0 auto", aspectRatio: "16/9", objectFit: "contain" }}
                        src={
                          process.env.PUBLIC_URL +
                          `/assets/images/Aboutus-img_new.png`
                        }
                        className="main-img"
                        alt=""
                      /></div>
        {/* Blog Area */}
        {/* <HomeBlog /> */}

        {/* Team Slider */}
        {/* <TeamSlider /> */}

        {/* Partner Slider */}
        {/* <PartnerSlider /> */}

        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
